var render = function render(){var _vm=this,_c=_vm._self._c;return _c('result-half-loan-loading')
}
var staticRenderFns = []

export { render, staticRenderFns }